import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Handle, NodeProps, Position } from "@xyflow/react";
import { FunctionComponent, useMemo } from "react";

import { Icon } from "@/components";

import { classNames } from "@/utils/classNames";

import { MyNode } from "../../CampaignOverview";

export const StarterNode: FunctionComponent<NodeProps<MyNode>> = (props) => {
	const { data } = props;

	const childrenNodes = data.getChildrenNodes?.(props.id) || [];

	const hasNextNode = useMemo(() => {
		return childrenNodes.length >= 1 || false;
	}, [childrenNodes]);

	return (
		<div
			className={classNames(
				"rounded-xl border p-4 h-auto relative w-[350px] flex flex-col items-center justify-center",
				data.isDisconnected
					? "border-status-error border-2 bg-status-error-light"
					: "border-gray-200",
				data.alreadySent ? "bg-brand-white" : !data.isDisconnected ? "bg-white" : ""
			)}
		>
			<div className="text-sm text-text-disabled">
				{!data.alreadySent ? "Sequence start" : "Sequence started"}
			</div>
			{(data.isDisconnected || data.hasOpenSource) && (
				<div className="text-xs text-status-error mt-1">Drag from here to reconnect</div>
			)}

			<div className="z-[100]">
				<Handle
					id="normalEdge"
					position={Position.Bottom}
					style={
						data.isDisconnected || data.hasOpenSource
							? {
									visibility: "visible",
									width: 12,
									height: 12,
									background: "#ef4444",
									border: "2px solid #fff",
									bottom: -6,
								}
							: { visibility: "hidden" }
					}
					type="source"
				/>
			</div>
			{!hasNextNode && (
				<div className="absolute bottom-[-35px] left-[50%] translate-x-[-50%] h-[35px] w-[1px] bg-text-meta opacity-50 z-[90]"></div>
			)}

			{!data.alreadySent && !data.scheduledFor && data?.handleAddStep && (
				<div
					className="bg-white shadow-md border border-border-light w-6 h-6 text-text-disabled p-2 rounded-full absolute bottom-[-55px] left-[50%] translate-x-[-50%] flex items-center justify-center z-[100]"
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();

						data?.handleAddStep?.({
							position: { x: props.positionAbsoluteX, y: props.positionAbsoluteY },
							initiatorId: props.id,
							edgeType: "normalEdge",
							nodeType: "starterNode",
							hasNextNode: hasNextNode,
						});
					}}
				>
					<Icon className="w-4 h-4" icon={faPlus} />
				</div>
			)}
		</div>
	);
};
